export default __webpack_public_path__ + "static/media/P104 zu P107.e87bde51.mp3";